module.exports = __webpack_public_path__ + "img/31.5f3721c7.webp";